export default "__VITE_ASSET__xvTiE27N__"